<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    ok-title="Guardar"
    cancel-title="Cancelar"
    @ok="handleSubmit"
    @hidden="resetForm"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-form-group label="Nombre del Edificio">
        <b-form-input
          v-model="form.nombre"
          placeholder="Ej: Edificio Central"
          required
        />
      </b-form-group>
      <b-form-group label="Descripción" class="mt-1">
        <b-form-input
          v-model="form.descripcion"
          placeholder="Ej: Edificio principal del campus"
        />
      </b-form-group>
      <b-form-group label="Estado" class="mt-1">
        <b-form-select
          v-model="form.estado"
          :options="statusOptions"
          required
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormSelect } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
  props: {
    buildingData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalId: 'building-modal',
      form: {
        edificioId: null,
        nombre: '',
        descripcion: '',
        estado: true,
      },
      statusOptions: [
        { text: 'Activo', value: true },
        { text: 'Inactivo', value: false }
      ],
    }
  },
  computed: {
    modalTitle() {
      return this.form.edificioId ? 'Editar Edificio' : 'Nuevo Edificio'
    },
  },
  watch: {
    buildingData(newData) {
      if (newData) {
        this.form = { ...newData }
      } else {
        this.resetForm()
      }
    },
  },
  methods: {
    handleSubmit() {
      // En una aplicación real, aquí se haría la llamada a la API
      this.$emit('submit', { ...this.form })
      this.$bvModal.hide(this.modalId)
    },
    resetForm() {
      this.form = {
        edificioId: null,
        nombre: '',
        descripcion: '',
        estado: true,
      }
    },
  },
}
</script>
